import { push } from "connected-react-router";
import { apiCall } from "../../util/Api";
import { isValidElement, isValidString } from "../../util/ApiHelper";
import { MY_EXIM_API_EXPORTER_OFFER_PRODUCTS } from "../services/exporterOfferProductsNetwork";
import { EXPORTER_OFFER_PRODUCTS_TYPES } from "../types/exporterOfferProductsTypes";
import { showAlert } from "../../util/helper";
import { all, put, takeLatest } from "redux-saga/effects";
import { FETCH_START, FETCH_SUCCESS } from "../types/commonTypes";
import { getExporterOfferProductsAction } from "../actions/exporterOfferProductsAction";

function* makeCreateExporterOfferProducts(action) {
  try {
    yield put({ type: FETCH_START });
    let response;
    if (isValidString(action?.id)) {
      response = yield apiCall(
        MY_EXIM_API_EXPORTER_OFFER_PRODUCTS.updateExporterOfferProduct,
        action
      );
    } else {
      response = yield apiCall(
        MY_EXIM_API_EXPORTER_OFFER_PRODUCTS.createExporterOfferProduct,
        action
      );
    }
    if (isValidElement(response)) {
      yield put(push(`/offer-your-cargo-exporter`));
      yield put({
        type: EXPORTER_OFFER_PRODUCTS_TYPES.CREATE_EXPORTER_OFFER_PRODUCT_SUCCESS,
        payload: response,
      });
    }
  } catch (e) {
    showAlert("error", "Something went wrong");
  } finally {
    yield put({ type: FETCH_SUCCESS });
  }
}

function* makeGetExporterOfferProductList(action) {
  try {
    yield put({ type: FETCH_START });
    const response = yield apiCall(
      MY_EXIM_API_EXPORTER_OFFER_PRODUCTS.getExporterOfferProductList,
      action
    );
    if (response.data) {
      yield put({
        type: EXPORTER_OFFER_PRODUCTS_TYPES.GET_EXPORTER_OFFER_PRODUCTS_LIST_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: EXPORTER_OFFER_PRODUCTS_TYPES.GET_EXPORTER_OFFER_PRODUCTS_LIST_FAILURE,
      error,
    });
    showAlert("error", "Failed to fetch offer products");
  } finally {
    yield put({ type: FETCH_SUCCESS });
  }
}

function* makeGetExporterOfferProductById(action) {
  try {
    yield put({ type: FETCH_START });
    const response = yield apiCall(
      MY_EXIM_API_EXPORTER_OFFER_PRODUCTS.getExporterOfferProductById,
      action.id
    );
    if (isValidElement(response?.data?.data)) {
      yield put({
        type: EXPORTER_OFFER_PRODUCTS_TYPES.GET_EXPORTER_OFFER_PRODUCT_BY_ID_SUCCESS,
        payload: response?.data?.data,
      });
    } else {
      yield put({
        type: EXPORTER_OFFER_PRODUCTS_TYPES.GET_EXPORTER_OFFER_PRODUCTS_LIST_SUCCESS,
        payload: null,
      });
    }
  } catch (e) {
    showAlert("error", e.message);
  } finally {
    yield put({ type: FETCH_SUCCESS });
  }
}

function* makeDeleteExporterOfferProduct(action) {
  try {
    yield put({ type: FETCH_START });
    yield apiCall(
      MY_EXIM_API_EXPORTER_OFFER_PRODUCTS.deleteExporterOfferProduct,
      action
    );

    yield put(getExporterOfferProductsAction(1, 10));

    yield put({
      type: EXPORTER_OFFER_PRODUCTS_TYPES.DELETE_EXPORTER_OFFER_PRODUCT_SUCCESS,
      product_id: action.product_id,
    });
  } catch (e) {
    showAlert(
      "error",
      e?.response?.data?.message || "Failed to delete Offer product"
    );
  } finally {
    yield put({ type: FETCH_SUCCESS });
  }
}

function* makeOfferProductsBuyerList(action) {
  try {
    yield put({ type: FETCH_START });
    const response = yield apiCall(
      MY_EXIM_API_EXPORTER_OFFER_PRODUCTS.getOfferProductsListBuyer,
      action
    );
    if (response.data) {
      yield put({
        type: EXPORTER_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_BUYER_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: EXPORTER_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_BUYER_FAILURE,
      error: error.message,
    });
    showAlert("error", "Failed to fetch offer products");
  } finally {
    yield put({ type: FETCH_SUCCESS });
  }
}

function* makeGetBuyerOfferProductById(action) {
  try {
    yield put({ type: FETCH_START });
    const response = yield apiCall(
      MY_EXIM_API_EXPORTER_OFFER_PRODUCTS.getBuyerOfferProductById,
      action.id
    );
    if(response.data) {
      yield put({
              type: EXPORTER_OFFER_PRODUCTS_TYPES.GET_BUYER_OFFER_PRODUCT_BY_ID_SUCCESS,
      payload: response.data,
      });
    }
  }catch(error) {
    yield put({
      type: EXPORTER_OFFER_PRODUCTS_TYPES.GET_BUYER_OFFER_PRODUCT_BY_ID_FAILURE,
      payload: error.message,
    });
    showAlert("error", "Failed to fetch offer products by id");
  }finally {
    yield put({ type: FETCH_SUCCESS });
  }
}

export default function* exporterOfferProductSaga() {
  yield all([
    takeLatest(
      EXPORTER_OFFER_PRODUCTS_TYPES.CREATE_EXPORTER_OFFER_PRODUCT,
      makeCreateExporterOfferProducts
    ),
    takeLatest(
        EXPORTER_OFFER_PRODUCTS_TYPES.GET_EXPORTER_OFFER_PRODUCTS_LIST,
        makeGetExporterOfferProductList
    ),
    takeLatest(
        EXPORTER_OFFER_PRODUCTS_TYPES.GET_EXPORTER_OFFER_PRODUCT_BY_ID,
        makeGetExporterOfferProductById
    ),
    takeLatest(
        EXPORTER_OFFER_PRODUCTS_TYPES.DELETE_EXPORTER_OFFER_PRODUCT,
        makeDeleteExporterOfferProduct
    ),
    takeLatest(
        EXPORTER_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_BUYER,
        makeOfferProductsBuyerList
    ),
    takeLatest(
      EXPORTER_OFFER_PRODUCTS_TYPES.GET_BUYER_OFFER_PRODUCT_BY_ID,
      makeGetBuyerOfferProductById
    )
  ]);
}
